import { FUNNELS_API } from 'modules/funnels/api/funnels-api'
import {
  CreateFunnelStepInterface,
  FunnelStepInterface,
} from 'modules/funnels/funnel/types/funnel-step-interface'
import { FunnelId } from 'modules/funnels/types/funnel-interface'
import { FunnelStepSourceEnum } from 'shared/enums/funnel-step-type-enum'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useAddFunnelStep = () => {
  const { fetcher } = useFetch<RequestMethodsEnum.post, FunnelStepInterface>({
    method: RequestMethodsEnum.post,
  })

  return {
    addFunnelStep: (id: FunnelId, data: CreateFunnelStepInterface) => {
      if (data.funnelStepSource === FunnelStepSourceEnum.StartFromScratch) {
        return fetcher(`${FUNNELS_API}/${id}/steps/empty`, { name: data.name, type: data.type })
      }
      return fetcher(`${FUNNELS_API}/${id}/steps`, { name: data.name, type: data.type })
    },
  }
}
